import { Component, ElementRef, HostListener, OnDestroy, OnInit, Renderer2, ViewChild } from "@angular/core";
import { AsmService } from "../../services/asm.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
// import { UserService } from "src/app/features/shared/user/services/user.service";
import { StorageService } from "src/app/features/http-services/storage.service";
import { finalize, map, mergeMap, Subject, switchMap, take, takeUntil } from "rxjs";
import { UserService } from "src/app/features/dashboard/user/services/user.service";

@Component({
  selector: "xchange-asm-ability",
  templateUrl: "./asm-ability.component.html",
  styleUrls: ["./asm-ability.component.scss"],
})
export class AsmAbilityComponent implements OnInit, OnDestroy {
  myForm!: FormGroup;
  suggestions: any[] = [];
  showSuggestions: boolean = false;
  isSuggestionSelected: boolean = false;
  hasCarts: boolean = false;
  startSession: boolean = false;
  showCart: boolean = false;
  cartData: any = [];
  userStartedTyping: boolean = false;
  showErrorMessage = false;
  spinnerLoading = false;
  errorMessage = "";
  @ViewChild("cartInput") cartInput!: ElementRef;
  preserveCardData: any;
  userDetail: any;
  isASMUser: any = false;
  customerQuerySubject = new Subject<string>();
  destroy$ = new Subject<void>();
  apiLoading: boolean = false;
  constructor(
    private asmService: AsmService,
    private fb: FormBuilder,
    private router: Router,
    private renderer: Renderer2,
    private storageService: StorageService,
    private userService: UserService,

  ) {}
  isFormVisible = true;
  submitButtonEnable=false;
  @HostListener('window:resize', ['$event'])
  onResize(event  :any) {
    // This ensures the scroll listener is only active on small screens
    if (event.target.innerWidth < 768) {
      this.isFormVisible = true; // Reset visibility when resizing to a small window
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event : any) {
    this.renderer.listen('window', 'scroll', () => {
      if (window.innerWidth < 768) {
        const mainPage = document.getElementById('mainPage');
        if (mainPage) {
          const scrollTop =  document.documentElement.scrollTop || document.body.scrollTop;
          if (scrollTop > 400) {
            this.isFormVisible = false;
          } else {
            this.isFormVisible = true;
          }
        } 
      }
    });
  }
  ngOnInit(): void {

   
    this.getUserDetail();
    this.createForm();
    this.storageService.getItem("customer-details").subscribe((response: any) => {
      this.isASMUser=response.isASMUser;
    })
    //  this.isASMUser = Boolean(localStorage.getItem("isASMUser"));
    //  console.log(this.isASMUser);
     
    const storedSessionState = sessionStorage.getItem("startSession");
    if (storedSessionState === "true") {
      this.startSession = true;
      this.submitButtonEnable = true;
      const storedEmail = sessionStorage.getItem("storedEmail");
      const storedCart = sessionStorage.getItem("storedCart");

      if (storedEmail) {
        this.myForm.get("email")?.setValue(storedEmail);
        this.myForm.get("email")?.disable();
      }

      // if (storedCart) {
      //   this.myForm.get("cart")?.setValue(storedCart);
      //   this.myForm.get("cart")?.disable();
      // }
      // this.updateProfile(this.myForm.value.email);
    }
    this.customerSearch();
  }

  createForm() {
    this.myForm = this.fb.group({
      email: [
        { value: "", disabled: false },
        [
          Validators.required,
          Validators.email,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      cart: [{ value: "", disabled: false }],
    });
  }

  onFormSubmit() {
    this.myForm.get("email")?.enable();
    this.myForm.get("cart")?.enable();
   
    if(!this.submitButtonEnable){
      return
    }
    
    if (this.myForm.valid) {
      this.spinnerLoading = true;
      this.showErrorMessage = false;
      this.errorMessage = "";
      if (!this.startSession) {
        this.spinnerLoading = false;
        this.startSession = true;
        sessionStorage.setItem("storedEmail", this.myForm.value.email);
        sessionStorage.setItem("storedCart", this.myForm.value.cart);
        this.showCart = false;
        sessionStorage.setItem("startSession", "true");
        this.myForm.get("email")?.disable();
        this.myForm.get("cart")?.disable();
        this.updateProfile(this.myForm.value.email);
      } else {
        this.spinnerLoading = false;
        this.startSession = false;
        sessionStorage.removeItem("startSession");
        sessionStorage.removeItem("storedEmail");
        sessionStorage.removeItem("storedCart");
        this.storageService.setItem("customer-address", "");
        this.storageService.setItem("salesman-selected", "");
        this.myForm.reset();
        this.updateProfile("");
      }
    }
  }
  
  getCustomerDetails$(addInIndexDB: boolean = true, username = "") {
    return this.storageService
      .getItem("customer-details")
      .pipe(
        take(1),
        map(customerDetails => ({ username: username || customerDetails?.uid, addInIndexDB })),
        mergeMap(data => this.userService.getCustomerDetails(data))
      );
  }
  
  updateProfile(email: any) {
    this.asmService.updateProfile(email).subscribe({
      next: (res) => {
        sessionStorage.setItem("isUidSet", "true");
        this.getCustomerDetails$(true, email || localStorage.getItem("userNamesTemp") || "")
        .pipe(take(1))
        .subscribe((res) => {
          this.asmService.getMiniCart({
            uid: res?.uid,
            customerNumber: res?.orgUnit?.uid,
          });
          //To set default Unit
          let custUid = res?.accounts?.uid;
          if (res?.isCustomer === true && custUid === undefined) {
            custUid = res?.accounts?.[0]?.uid;
          }
          if (res?.isSalesPerson === true) {
            custUid = res?.orgUnit?.uid;
          }
          if (
            !(res?.accounts?.length > 1) &&
            res?.accounts?.length !== undefined &&
            res?.accounts?.length !== 0
          ) {
            this.storageService.getItem("customer-details")
            .pipe(take(1))
            .subscribe(response => {
              this.asmService.setDefaultUnit({
                userId: response.uid,
                unitUid: custUid || ""
              })
              .pipe(take(1))
              .subscribe(() => {
                if (!email) {
                  window && window.location.replace("/");
                } else {
                  this.asmService.navigateUsers(res);
                }
              });
            });
            // this.userService.setUnit("?unitUid=" + custUid).subscribe();
          } else {
            this.asmService.navigateUsers(res);
          }
        });
      },
    });
  }

  onChangeValue(customerQueries: any) {
    this.showCart = false;
    this.isSuggestionSelected = false;
    let query = customerQueries.value;

    if (typeof query === "string") {
      query = query.trim();

      this.showSuggestions = query.length >= 3;

      if (query.length >= 3) {
 
      this.customerQuerySubject.next(query);
 
    } else {
      this.suggestions = [];
    }
  } else {
    this.suggestions = [];
    this.showSuggestions = false;
  }
}
  selectSuggestion(suggestion: any) {
    this.myForm.patchValue({
      email: suggestion.email,
    });
    this.suggestions = [];
    this.showSuggestions = false;
    this.cartData = suggestion?.carts;
    this.preserveCardData = [...this.cartData]; //To preserve the cartData
    if (this.cartData) {
      this.showCart = true;
      this.cartInput.nativeElement.focus();
    }
  }
  selectCart(carts: any) {
    this.myForm.patchValue({
      cart: carts,
    });
    this.showCart = false;
  }
  onChangeCartValue(cartValue: any) {
    if (this.cartData.length == 0 && !this.userStartedTyping) {
      this.showCart = false;
    } else if (this.cartData.length && this.userStartedTyping) {
      this.showCart = true;
    }
  }

  onCartInput(inputValue: any) {
    this.cartData = [...this.preserveCardData];
    this.userStartedTyping = inputValue.value.length > 0;
    if (this.userStartedTyping) {
      // Filter cartData based on the query
      const filteredCarts = this.cartData.filter((cart: any) =>
        cart.toLowerCase().includes(inputValue.value)
      );
      this.cartData = filteredCarts;
      // Show the suggestions
      this.showCart = filteredCarts.length > 0;
    } else {
      this.cartData = [...this.preserveCardData];
      this.showCart = true; // Show all suggestions
    }
  }

  clearCartinput() {
    this.cartData = [...this.preserveCardData];
    this.myForm.patchValue({
      cart: "",
    });
    this.userStartedTyping = false; // Reset userStartedTyping flag
    this.showCart = true; // Show all carts
  }
  getUserDetail() {
    // this.spinnerLoading = true;
    // this.userService.getCurrentUserDetail().subscribe((res: any) => {
    //   this.userDetail = res.body;
    //   this.spinnerLoading = false;
    // }),
    //   (err: any) => {
    //     this.spinnerLoading = false;
    //   };
    this.userDetail = this.storageService.currentUserData;
  
  }

  customerSearch() {
    this.customerQuerySubject.pipe(
  switchMap(query => {
    this.apiLoading = true;
    this.suggestions = [];
    return this.asmService.getAutoComplete(query).pipe(
      finalize(() => {
        this.apiLoading = false;
      })
    );
  }),
  takeUntil(this.destroy$)
).subscribe({
      next: (res) => {
        this.suggestions = res?.body;
        if (res?.error) {
          this.submitButtonEnable = false;
        } else {
          this.submitButtonEnable = true;
        }
        this.showSuggestions = true;
      },
      error: () => {
        this.submitButtonEnable = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.customerQuerySubject.complete();
  }
}
